// import logo from './logo.svg';
// import './App.css';
// import LoginPage from './paginas/LoginPage';

// function App() {
//   return (
//     <>
//       <LoginPage/>
//      </>
//   );
// }

// export default App;

// import React from 'react';
// import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// import Login from './paginas/Login';
// import Registro from './paginas/Registro';

// const App = () => {
//   return (
//     <Router>
//       <Routes>
//         <Route path="/login" element={<Login />} />
//         <Route path="/registro" element={<Registro />} />
//         <Route path="/" element={<Login />} />
//       </Routes>
//     </Router>
//   );
// };

// export default App;

// import React, { useState } from 'react';
// import { BrowserRouter as Router, Routes, Route, Link, useNavigate } from 'react-router-dom';
// import './styles.css';

// const App = () => {
//   return (
//     <Router>
//       <Routes>
//         <Route path="/" element={<Login />} />
//         <Route path="/register" element={<Register />} />
//       </Routes>
//     </Router>
//   );
// };

// const Login = () => {
//   const [username, setUsername] = useState('');
//   const [password, setPassword] = useState('');
//   const [showPassword, setShowPassword] = useState(false);
//   const [rememberMe, setRememberMe] = useState(false);
  
//   const handleSubmit = (e) => {
//     e.preventDefault();
//     console.log('Login submitted:', { username, password, rememberMe });
//   };
  
//   return (
//     <div className="mobile-container">
//       <div className="header">
//         <h3>Mobile Login</h3>
//       </div>
      
//       <div className="content">
//         <h2>Welcome to lorem.!</h2>
        
//         <div className="tab-buttons">
//           <Link to="/" className="tab-button active">Login</Link>
//           <Link to="/register" className="tab-button">Register</Link>
//         </div>
        
//         <p className="description">
//           Lorem Ipsum is simply dummy text of the printing and typesetting industry.
//         </p>
        
//         <form onSubmit={handleSubmit}>
//           <div className="form-group">
//             <label htmlFor="username">User name</label>
//             <div className="input-container">
//               <input
//                 type="text"
//                 id="username"
//                 placeholder="Enter your User name"
//                 value={username}
//                 onChange={(e) => setUsername(e.target.value)}
//                 required
//               />
//             </div>
//           </div>
          
//           <div className="form-group">
//             <label htmlFor="password">Password</label>
//             <div className="input-container">
//               <input
//                 type={showPassword ? "text" : "password"}
//                 id="password"
//                 placeholder="Enter your Password"
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 required
//               />
//               <button
//                 type="button"
//                 className="toggle-password"
//                 onClick={() => setShowPassword(!showPassword)}
//               >
//                 {showPassword ? "👁️" : "👁️"}
//               </button>
//             </div>
//           </div>
          
//           <div className="form-footer">
//             <div className="remember-me">
//               <input
//                 type="checkbox"
//                 id="remember"
//                 checked={rememberMe}
//                 onChange={() => setRememberMe(!rememberMe)}
//               />
//               <label htmlFor="remember">Remember me</label>
//             </div>
//             <a href="#" className="forgot-password">Forgot Password?</a>
//           </div>
          
//           <button type="submit" className="submit-button">Login</button>
//         </form>
//       </div>
//     </div>
//   );
// };

// const Register = () => {
//   const [currentStep, setCurrentStep] = useState(1);
//   const [formData, setFormData] = useState({
//     email: '',
//     username: '',
//     password: '',
//     name: '',
//     nickname: '',
//     school: '',
//     birthdate: '',
//     address: '',
//     city: '',
//     state: '',
//     phoneNumber: '',
//     photo: null,
//   });
//   const [showPassword, setShowPassword] = useState(false);
  
//   const totalSteps = 3;
  
//   const handleChange = (e) => {
//     const { name, value, type, files } = e.target;
//     if (type === 'file') {
//       setFormData({ ...formData, [name]: files[0] });
//     } else {
//       setFormData({ ...formData, [name]: value });
//     }
//   };
  
//   const nextStep = () => {
//     if (currentStep < totalSteps) {
//       setCurrentStep(currentStep + 1);
//     }
//   };
  
//   const prevStep = () => {
//     if (currentStep > 1) {
//       setCurrentStep(currentStep - 1);
//     }
//   };
  
//   const handleSubmit = (e) => {
//     e.preventDefault();
//     console.log('Registration submitted:', formData);
//     // Submit logic here
//   };
  
//   const renderStep = () => {
//     switch (currentStep) {
//       case 1:
//         return (
//           <>
//             <div className="form-group">
//               <label htmlFor="email">Email Address</label>
//               <div className="input-container">
//                 <input
//                   type="email"
//                   id="email"
//                   name="email"
//                   placeholder="Enter your Email Address"
//                   value={formData.email}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>
//             </div>
            
//             <div className="form-group">
//               <label htmlFor="username">User name</label>
//               <div className="input-container">
//                 <input
//                   type="text"
//                   id="username"
//                   name="username"
//                   placeholder="Enter your User name"
//                   value={formData.username}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>
//             </div>
            
//             <div className="form-group">
//               <label htmlFor="password">Password</label>
//               <div className="input-container">
//                 <input
//                   type={showPassword ? "text" : "password"}
//                   id="password"
//                   name="password"
//                   placeholder="Enter your Password"
//                   value={formData.password}
//                   onChange={handleChange}
//                   required
//                 />
//                 <button
//                   type="button"
//                   className="toggle-password"
//                   onClick={() => setShowPassword(!showPassword)}
//                 >
//                   {showPassword ? "👁️" : "👁️"}
//                 </button>
//               </div>
//             </div>
//           </>
//         );
        
//       case 2:
//         return (
//           <>
//             <div className="form-group">
//               <label htmlFor="name">Full Name</label>
//               <div className="input-container">
//                 <input
//                   type="text"
//                   id="name"
//                   name="name"
//                   placeholder="Enter your Full Name"
//                   value={formData.name}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>
//             </div>
            
//             <div className="form-group">
//               <label htmlFor="nickname">Nickname</label>
//               <div className="input-container">
//                 <input
//                   type="text"
//                   id="nickname"
//                   name="nickname"
//                   placeholder="Enter your Nickname"
//                   value={formData.nickname}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>
//             </div>
            
//             <div className="form-group">
//               <label htmlFor="school">School</label>
//               <div className="input-container">
//                 <input
//                   type="text"
//                   id="school"
//                   name="school"
//                   placeholder="Enter your School"
//                   value={formData.school}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>
//             </div>
            
//             <div className="form-group">
//               <label htmlFor="birthdate">Birth Date</label>
//               <div className="input-container">
//                 <input
//                   type="date"
//                   id="birthdate"
//                   name="birthdate"
//                   value={formData.birthdate}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>
//             </div>
//           </>
//         );
        
//       case 3:
//         return (
//           <>
//             <div className="form-group">
//               <label htmlFor="address">Address</label>
//               <div className="input-container">
//                 <input
//                   type="text"
//                   id="address"
//                   name="address"
//                   placeholder="Enter your Address"
//                   value={formData.address}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>
//             </div>
            
//             <div className="form-group">
//               <label htmlFor="city">City</label>
//               <div className="input-container">
//                 <input
//                   type="text"
//                   id="city"
//                   name="city"
//                   placeholder="Enter your City"
//                   value={formData.city}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>
//             </div>
            
//             <div className="form-group">
//               <label htmlFor="state">State</label>
//               <div className="input-container">
//                 <input
//                   type="text"
//                   id="state"
//                   name="state"
//                   placeholder="Enter your State"
//                   value={formData.state}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>
//             </div>
            
//             <div className="form-group">
//               <label htmlFor="phoneNumber">Phone Number</label>
//               <div className="input-container">
//                 <input
//                   type="tel"
//                   id="phoneNumber"
//                   name="phoneNumber"
//                   placeholder="Enter your Phone Number"
//                   value={formData.phoneNumber}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>
//             </div>
            
//             <div className="form-group">
//               <label htmlFor="photo">Profile Photo</label>
//               <div className="input-container">
//                 <input
//                   type="file"
//                   id="photo"
//                   name="photo"
//                   accept="image/*"
//                   onChange={handleChange}
//                   required
//                 />
//               </div>
//             </div>
//           </>
//         );
        
//       default:
//         return null;
//     }
//   };
  
//   return (
//     <div className="mobile-container">
//       <div className="header">
//         <h3>Mobile Register</h3>
//       </div>
      
//       <div className="content">
//         <h2>Welcome to lorem.!</h2>
        
//         <div className="tab-buttons">
//           <Link to="/" className="tab-button">Login</Link>
//           <Link to="/register" className="tab-button active">Register</Link>
//         </div>
        
//         <p className="description">
//           Lorem Ipsum is simply dummy text of the printing and typesetting industry.
//         </p>
        
//         <div className="progress-indicator">
//           {Array.from({ length: totalSteps }, (_, i) => (
//             <div 
//               key={i} 
//               className={`step ${currentStep > i ? 'completed' : ''} ${currentStep === i+1 ? 'active' : ''}`}
//             >
//               {i+1}
//             </div>
//           ))}
//         </div>
        
//         <form onSubmit={handleSubmit}>
//           {renderStep()}
          
//           <div className="step-buttons">
//             {currentStep > 1 && (
//               <button 
//                 type="button" 
//                 className="prev-button" 
//                 onClick={prevStep}
//               >
//                 Previous
//               </button>
//             )}
            
//             {currentStep < totalSteps ? (
//               <button 
//                 type="button" 
//                 className="next-button" 
//                 onClick={nextStep}
//               >
//                 Next
//               </button>
//             ) : (
//               <button 
//                 type="submit" 
//                 className="submit-button"
//               >
//                 Register
//               </button>
//             )}
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default App;

import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './paginas/Login';
import Registro from './paginas/Registro';
import ReadPage from './paginas/ReadPage';
import CoursesPage from './paginas/CoursesPage';
import CourseDetailPage from './paginas/CourseDetailPage';
import Dashboard from './paginas/Dashboard';
import ProfileDashboard from './paginas/ProfileDashboard';
import StudentDashboard from './paginas/StudentDashboard';
import TeacherDashboard from './paginas/TeacherDashboard';
import Lero from './paginas/Lero';
import AboutUs from './paginas/AboutUs';
import ContactUs from './paginas/ContactUs';
import ContentPage from './paginas/ContentPage';
import Downloads from './paginas/Downloads';
import ProtectedRoute from './paginas/ProtectedRoute';
import Jogos from './paginas/Jogos';

const App = () => {
  return (
    // <Router>
    //   <Routes>
    //     {/* <Route path="/Login" element={<Login />} /> */}
    //     {/* <Route path="/" element={<Registro />} /> */}
    //     {/* <Route path="/" element={<Login />} /> */}
    //     {/* <Route path="/" element={<ReadPage />} /> */}
    //     {/* <Route path="/" element={<CoursesPage />} /> */}
    //     {/* <Route path="/" element={<CourseDetailPage/> }/> */}
    //     {/* <Route path="/" element={<Dashboard/> }/> */}
    //     {/* <Route path="/" element={<ProfileDashboard/> }/> */}
    //     {/* <Route path="/" element={<CourseDetailPage/> }/> */}
    //     {/* <Route path="/" element={<StudentDashboard/> }/> */}
    //     {/* <Route path="/" element={<TeacherDashboard/> }/> */}
    //     <Route path="/" element={<Lero/> }/>
    //     <Route path="/AboutUs" element={<AboutUs/> }/>
    //     <Route path="/ContactUs" element={<ContactUs/> }/>
    //     <Route path="/ContentPage" element={<ContentPage/> }/>
    //     <Route path="/Downloads" element={<Downloads />} />
    // //   </Routes>
    // </Router>




    <Router>
      {/* <Routes>
      <Route path="/" element={<Lero />} />
      <Route path="/Login" element={<Login />} />
      <Route path="/Registro" element={<Registro />} />
      <Route path="/AboutUs" element={<AboutUs />} />
      <Route path="/ContactUs" element={<ContactUs />} />
      <Route path="/Downloads" element={<Downloads />} />
      <Route path="/ContentPage" element={<ContentPage/> }/>
      <Route path="/login" element={<Login />} />
      <Route path="/Registro" element={<Registro />} />
 */}


      {/* <Route path="/" element={<ReadPage />} /> */}
      {/* <Route path="/" element={<ContactUs/> }/> */}
        {/* <Route path="/" element={<ContentPage/> }/> */}
        {/* <Route path="/" element={<Downloads />} />
        <Route path="/" element={<Lero />} />
        <Route path="/" element={<Login />} />
        <Route path="/" element={<Registro />} />
        <Route path="/" element={<AboutUs />} />
        <Route path="/" element={<ContactUs />} /> */}
        {/* <Route path="/lero" element={<Lero />} /> */}

        <Routes>
                    <Route path="/" element={<Lero />} />
      <Route path="/Login" element={<Login />} />
      <Route path="/Registro" element={<Registro />} />
      <Route path="/AboutUs" element={<AboutUs />} />
      <Route path="/ContactUs" element={<ContactUs />} />
      <Route path="/Downloads" element={<Downloads />} />
      <Route path="/ContentPage" element={<ContentPage/> }/>
      <Route path="/Jogos" element={<Jogos/> }/>
      <Route path="/login" element={<Login />} />
      <Route path="/Registro" element={<Registro />} />
                    <Route
                        path="/student-dashboard"
                        element={
                            <ProtectedRoute requiredType={1}>
                                <StudentDashboard />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/teacher-dashboard"
                        element={
                            <ProtectedRoute requiredType={2}>
                                <TeacherDashboard />
                            </ProtectedRoute>
                        }
                    />
                    <Route path="/read/:id" element={<ReadPage />} />                
                {/* </Routes> */}
      </Routes>
    </Router>
  );
};

export default App;